<template>
  <div class="header-flex-container">
    <div class="header-left-spaces"></div>
    <div class="header-content">
      <div class="logo">
        <img src="//img.netwrix.com/netwrix-logo-no-tagline@2x.png" alt="Logos">
      </div>
      <div class="buttons">
        <span class="btn btn-bordered-red">Request Pricing</span>
        <span class="btn btn-bordered-blue">Request One-to-One Demo</span>
      </div>
    </div>
    <div class="header-right-spaces">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageHeader',
  };
</script>

<style lang="less" scoped>
  .header-flex-container {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    height: 89px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .2);
    background: #fff;
    min-width: 1445px;
    position: relative;
    z-index: 4;
  }

  .header-left-spaces, .header-right-spaces {
    padding: 40px 0;
    display: flex;
    align-items: stretch;
  }

  .header-left-spaces {
    flex: 1 0 0;
    min-width: 22px;
  }

  .header-right-spaces {
    flex: 1 0 0;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: auto;
    flex: 0 0 1445px;

    .logo {
      img {
        width: 128px;
      }
    }

    .buttons {
      padding: 24px 0;

      .btn-bordered-red, .btn-bordered-blue {
        border-radius: 5px;
        border: 2px solid #da262e;
        color: #da262e;
        font-size: 1.4rem;
        font-weight: 600;

        &:hover, &:focus, &:active {
          background: #da262e;
          color: #fff;
        }
      }

      .btn-bordered-blue {
        border: 2px solid #008cce;
        color: #008cce;
        &:hover, &:focus, &:active {
          background: #008cce;
        }
      }

      span {
        padding: 8px 20px;
        min-width: 225px;
        margin-left: 30px;
      }
    }
  }
</style>